import React from "react";


const clickableParagraphHavingUrlsAndLinebreak = (text) => {
  const urlRegex = /(https?:\/\/[^\s]+)/g;
  return text.split('\n').map((line, lineIndex) => (
    <React.Fragment key={lineIndex}>
      {line.split(urlRegex).map((part, index) => {
        if (urlRegex.test(part)) {
          return (
            <a
              key={index}
              href={part}
              className="text-blue-600 underline"
              target="_blank"
              rel="noopener noreferrer"
            >
              {part}
            </a>
          );
        }
        return <span key={index}>{part}</span>;
      })}
      <br />
    </React.Fragment>
  ));
};

export { clickableParagraphHavingUrlsAndLinebreak };